module.exports = __webpack_public_path__ + "static/media/aurora-win.9ba5afaa.png";